import {
  ADD_GAME_TO_CART,
  ADD_GAME_TO_USER,
  ADD_GAME_TO_USER_FAV,
  FETCH_GAMES,
  REMOVE_GAME_FROM_CART,
  REMOVE_GAME_FROM_USER_FAV,
} from "../actions/types";
import firebase from "firebase";
import axios from "axios";

export const fetchGames = () => async (dispatch) => {
  dispatch({
    type: FETCH_GAMES,
    payload: -1,
  });
  let snapshot = await firebase
    .firestore()
    .collection("games")
    .where("isAvailable", "==", true)
    .get();
  let data = [];
  for (let doc of snapshot.docs) {
    data.push({ id: doc.id, ...doc.data() });
  }
  dispatch({
    type: FETCH_GAMES,
    payload: data,
  });
};

export const addGameToCard = (id) => {
  return {
    type: ADD_GAME_TO_CART,
    payload: id,
  };
};

export const removeGameFromCard = (id) => {
  return {
    type: REMOVE_GAME_FROM_CART,
    payload: id,
  };
};

export const addGamesToUser = (details) => async (dispatch) => {
  dispatch({ type: "ACTION_REQUEST" });
  let userObj = JSON.parse(localStorage.getItem("user_info"));
  var cartGames = JSON.parse(localStorage.getItem("cart"));
  var allGames = await firebase.firestore().collection("games").get();
  var requiredGames = [];
  allGames.docs.forEach((doc) => {
    if (cartGames.includes(doc.id)) {
      requiredGames.push({ id: doc.id, ...doc.data() });
    }
  });
  var totalPrice = requiredGames.reduce((acc, val) => {
    return (acc = acc + val.price);
  }, 0);
  //   console.log(totalPrice);
  const config = {
    headers: {
      "Content-Type": " application/json",
    },
  };
  var body = {
    token: details.stripeToken,
    email: userObj.email,
    user_id: userObj.id,
    game_ids: cartGames,
    amount: totalPrice * 100,
  };

  await axios
    .post(
      "https://us-central1-cr-mobile-13fb4.cloudfunctions.net/app/api/v1/stripe/buyGames",
      body,
      config
    )
    .then(async function (res) {
      dispatch({ type: "ACTION_REQUEST_END" });
    });
  dispatch({
    type: "BOUGHT_GAME",
  });
  await cartGames.forEach((doc) => {
    dispatch(removeGameFromCard(doc));
  });
};
export const boughtFinish = () => async (dispatch) => {
  dispatch({ type: "BOUGHT_GAME_END" });
};
export const addGameToUserFav = (gameId) => async (dispatch) => {
  let userObj = JSON.parse(localStorage.getItem("user_info"));
  if (userObj != null) {
    let uid = userObj.id;
    dispatch({
      type: ADD_GAME_TO_USER_FAV,
      payload: -1,
    });
    let user = await firebase.firestore().collection("users").doc(uid).get();
    user = user.data();
    if (user.my_favourites == null) {
      user.my_favourites = [];
    }
    user.my_favourites.push(gameId);
    await firebase.firestore().collection("users").doc(uid).update(user);
    dispatch({
      type: ADD_GAME_TO_USER_FAV,
      payload: gameId,
    });
  }
};
export const removeGameFromUserFav = (gameId) => async (dispatch) => {
  let userObj = JSON.parse(localStorage.getItem("user_info"));
  if (userObj != null) {
    let uid = userObj.id;
    dispatch({
      type: REMOVE_GAME_FROM_USER_FAV,
      payload: -1,
    });
    let user = await firebase.firestore().collection("users").doc(uid).get();
    user = user.data();
    if (user.my_favourites == null) {
      user.my_favourites = [];
    }
    user.my_favourites = user.my_favourites.filter((fav) => fav != gameId);
    await firebase.firestore().collection("users").doc(uid).update(user);
    dispatch({
      type: REMOVE_GAME_FROM_USER_FAV,
      payload: gameId,
    });
  }
};
